/* unplugin-vue-components disabled */import { render } from "./w-dialog.vue?vue&type=template&id=50fad010&scoped=true&ts=true"
import script from "./w-dialog.vue?vue&type=script&lang=ts"
export * from "./w-dialog.vue?vue&type=script&lang=ts"

import "./w-dialog.vue?vue&type=style&index=0&id=50fad010&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50fad010"]])

export default __exports__